import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { RouteFilterConstants as Constants } from './route-filter.constants'
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'aw-route-filter',
    templateUrl: './route-filter.component.html',
    styleUrls: ['./route-filter.component.less'],
    imports: [MatFormField, MatInput, FormsModule, MatIcon, MatSuffix]
})
export class RouteFilterComponent implements OnInit {
    @Input() placeHolderText: string;
    @Input() filterName: string;
    filter: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => this.filter = params[this.filterName]);
    }

    public filterChanged($event: Event) {
        this.router.navigate([],
            {
                relativeTo: this.activatedRoute,
                queryParams: {
                    [this.filterName]: $event,
                },
                queryParamsHandling: Constants.queryParamsHandlingMerge
            });
    }

    public clearFilter(): void {
        this.filter = null;
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
                [this.filterName]: null
            },
            queryParamsHandling: Constants.queryParamsHandlingMerge
        });
    }
}
